import {
  BarChart3Icon,
  BriefcaseBusinessIcon,
  FileTextIcon,
  Globe2Icon,
  LayoutDashboardIcon,
  LinkIcon,
  UsersIcon,
  type LucideIcon
} from 'lucide-react';
import type { NavigationIconName } from '@cdf/navigation-catalogue';

export const customPageIcons = {
  'layout-dashboard': LayoutDashboardIcon,
  'file-text': FileTextIcon,
  'bar-chart': BarChart3Icon,
  users: UsersIcon,
  briefcase: BriefcaseBusinessIcon,
  links: LinkIcon,
  globe: Globe2Icon
} satisfies Record<NavigationIconName, LucideIcon>;

export type CustomPageIconName = NavigationIconName;

export const customPageIconOptions: Array<{ value: CustomPageIconName; label: string }> = [
  { value: 'layout-dashboard', label: 'Dashboard' },
  { value: 'file-text', label: 'Document' },
  { value: 'bar-chart', label: 'Chart' },
  { value: 'users', label: 'People' },
  { value: 'briefcase', label: 'Work' },
  { value: 'links', label: 'Links' },
  { value: 'globe', label: 'Public website' }
];

export function getCustomPageIcon(name: string | null | undefined): LucideIcon {
  return customPageIcons[name as CustomPageIconName] ?? LayoutDashboardIcon;
}
